import { API } from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getSignupNotificationEmails = createAsyncThunk(
  'signupNotificationEmails/get',
  API.signupNotificationEmails.get,
);

export const addSignupNotificationEmail = createAsyncThunk(
  'signupNotificationEmails/add',
  async ({ email }: { email: string }) => API.signupNotificationEmails.add({ email }),
);

export const deleteSignupNotificationEmail = createAsyncThunk(
  'signupNotificationEmails/delete',
  async ({ email }: { email: string }) => API.signupNotificationEmails.remove({ email }),
);
